import React from "react";

import { Props } from "./types";

function EditIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 15.506 15.51">
      <path
        d="M5.645,13.569,2.128,10.051l8.509-8.509L14.154,5.06ZM1.8,10.671,5.026,13.9.188,15.509ZM15.236,3.983l-.61.61L11.1,1.07l.61-.61a1.573,1.573,0,0,1,2.226,0l1.3,1.3A1.582,1.582,0,0,1,15.236,3.983Zm0,0"
        transform="translate(-0.188 0.001)"
      />
    </svg>
  );
}

export { EditIcon };
